import React from 'react';
import Link from 'gatsby-link';

import Button from '@marvelapp/marvel-ui/button';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import MediaSingleImage from 'marketing-website/components/modules/Media/MediaSingleImage';

import assets from 'marketing-website/configs/pages/why-marvel/assets.js';

export default function Creativity() {
  return (
    <PageWrap size="l">
      <Spacing size="l" sizeM="xl" type="padding" position="topBottom">
        <MediaSingleImage
          {...assets.browser}
          copy={
            <span>
              Create beautiful wireframes, mockups, website or app prototypes
              for any device right from your browser.
              <br />
              <br />
              Sync designs from Sketch, upload your images or build mockups
              directly within our design tool where you'll find millions of
              assets, stock photos and icons at your fingertips.
            </span>
          }
          headingSpacing="m"
          shapes
          title="Design anything, anywhere."
        >
          <Link to="/features/design">
            <Button shape="rounded" kind="ghost" size="large">
              Learn more
            </Button>
          </Link>
        </MediaSingleImage>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/why-marvel/Creativity.js